module.exports = __webpack_public_path__ + "static/media/crew-neck-tshirt.f0904d01.jpg";